<template>
	<section
		class="w-64 flex flex-col justify-between bg-gray-900 bg-opacity-100 rounded-2xl px-6 py-4 shadow-lg">
		<div class="flex items-center justify-between">
			<span class="text-gray-400 text-sm">
				{{ date === 'today' ? date : date + ' ago' }}
			</span>
			<span class="text-emerald-400">
				<button
					:class="!available ? 'bg-green-600' : 'bg-red-500'"
					class="ml-4 px-4 py-2 rounded-xl flex items-center text-xs uppercase font-bold leading-snug text-white hover:bg-opacity-75">
					<span>{{ !available ? 'Available' : 'Unavailable' }}</span>
				</button>
			</span>
		</div>
		<div class="mt-4 w-fit mx-auto">
			<img
				:src="imageUrl"
				class="w-full"
				alt="profile picture"
				srcset="" />
		</div>

		<div>
			<div class="flex flex-col md:flex-row md:justify-between mt-4">
				<div class="flex items-center">
					<Check v-if="material.minidrafter === true" />
					<Uncheck v-else />
					<span class="text-white text-sm pl-2 py-1 tracking-wide">
						MiniDrafter
					</span>
				</div>
				<div class="flex items-center">
					<Check v-if="material.container === true" />
					<Uncheck v-else />
					<span class="text-white text-sm pl-2 py-1 tracking-wide">
						Container
					</span>
				</div>
			</div>
			<div class="flex flex-col md:flex-row md:justify-between">
				<div class="flex items-center">
					<Check v-if="material.frenchCurve === true" />
					<Uncheck v-else />
					<span class="text-white text-sm pl-2 py-1 tracking-wide">
						French curve
					</span>
				</div>
				<div class="flex items-center">
					<Check v-if="material.scales === true" />
					<Uncheck v-else />
					<span class="text-white text-sm pl-2 py-1 tracking-wide">Scales</span>
				</div>
			</div>

			<div class="flex flex-col items-start md:flex-row text-md mt-2">
				<p class="text-gray-300">Contact:&nbsp;</p>
				<p class="text-gray-300">{{ contact }}</p>
			</div>

			<div
				:class="profilePage ? '' : 'hidden'"
				class="flex justify-between mt-4 space-x-3 md:mt-6">
				<div>
					<button
						v-on:click="toggleModal()"
						class="inline-flex items-center px-6 py-2 text-sm font-medium text-center text-gray-200 border border-gray-200 rounded-lg hover:border-gray-300 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
						Edit
					</button>
					<div
						v-if="showModal"
						v-on:click="toggleModal()"
						class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
						<div class="relative my-6 mx-auto max-w-6xl">
							<!--content-->
							<div
								@click.stop="() => {}"
								class="px-8 py-8 w-80 border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
								<!--header-->
								<div
									class="pb-4 flex items-center justify-between border-b border-solid border-slate-200 rounded-t">
									<h3 class="text-xl font-semibold">Add Instrument</h3>
									<button
										class="ml-auto bg-transparent border-0 text-black text-xl leading-none font-semibold outline-none focus:outline-none"
										v-on:click="toggleModal()">
										<span
											class="bg-transparent block outline-none focus:outline-none">
											X
										</span>
									</button>
								</div>
								<!--body-->
								<form
									class="space-y-6"
									@submit.prevent="handleSubmit()">
									<input
										v-model="imageUrl"
										class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
										type="url"
										autocomplete="on"
										placeholder="Image URL" />
									<input
										v-model="contact"
										class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
										type="tel"
										pattern="[0-9]{10}"
										autocomplete="on"
										placeholder="Contact" />

									<div>
										<h3
											class="mb-1 font-semibold text-gray-900 dark:text-white">
											Instruments
										</h3>
										<ul
											class="w-full text-sm font-medium flex justify-between text-gray-900 bg-white rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
											<span>
												<li
													class="w-full rounded-t-lg border-b border-gray-200 dark:border-gray-600">
													<div class="flex items-center pl-3">
														<input
															id="vue-checkbox"
															type="checkbox"
															v-model="minidrafter"
															value="minidrafter"
															class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
														<label
															for="vue-checkbox"
															class="py-3 pl-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300">
															Minidrafter
														</label>
													</div>
												</li>
												<li
													class="w-full rounded-t-lg border-b border-gray-200 dark:border-gray-600">
													<div class="flex items-center pl-3">
														<input
															id="react-checkbox"
															type="checkbox"
															v-model="frenchCurve"
															value="frenchCurve"
															class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
														<label
															for="react-checkbox"
															class="py-3 pl-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300">
															FrenchCurve
														</label>
													</div>
												</li>
											</span>
											<span>
												<li
													class="w-full rounded-t-lg border-b border-gray-200 dark:border-gray-600">
													<div class="flex items-center pl-3">
														<input
															id="angular-checkbox"
															type="checkbox"
															v-model="container"
															value="container"
															class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
														<label
															for="angular-checkbox"
															class="py-3 pr-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300">
															Container
														</label>
													</div>
												</li>
												<li
													class="w-full rounded-t-lg border-b border-gray-200 dark:border-gray-600">
													<div class="flex items-center pl-3">
														<input
															id="laravel-checkbox"
															type="checkbox"
															v-model="scales"
															value="scales"
															class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
														<label
															for="laravel-checkbox"
															class="py-3 pr-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300">
															Scales
														</label>
													</div>
												</li>
											</span>
										</ul>
									</div>

									<div
										class="flex items-center justify-between border-t border-solid border-slate-200 rounded-b">
										<button
											class="text-purple-800 bg-transparent border border-solid border-purple-800 hover:bg-purple-800 hover:text-white active:bg-red-600 font-bold uppercase text-sm px-4 py-3 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
											type="button"
											v-on:click="toggleModal()">
											Close
										</button>
										<button
											type="submit"
											class="flex justify-center bg-purple-800 hover:bg-purple-700 text-gray-100 p-3 rounded-lg tracking-wide font-semibold cursor-pointer transition ease-in duration-500">
											Submit
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
					<div
						v-if="showModal"
						class="opacity-25 fixed inset-0 z-40 bg-black"></div>
				</div>
				<a
					v-if="!available"
					@click="handleDelete()"
					class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-gray-900 bg-red-400 bg-opacity-80 rounded-lg hover:bg-opacity-75 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:ring-gray-700">
					Mark sold
				</a>
				<a
					v-else
					@click="handleDelete()"
					class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-gray-900 bg-red-400 bg-opacity-80 rounded-lg hover:bg-opacity-75 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:ring-gray-700">
					Mark available
				</a>
			</div>
		</div>
	</section>
</template>

<script>
import axios from 'axios'
import Check from '@/components/Check.vue'
import Uncheck from '@/components/Uncheck.vue'

export default {
	name: 'Card',
	data() {
		return {
			showModal: false,
			profilePage: false
		}
	},
	mounted() {
		if (this.$route.name == 'profile') this.profilePage = true
	},
	methods: {
		toggleModal: function () {
			this.showModal = !this.showModal
		},
		async handleSubmit() {
			let instruments = []
			if (this.container) instruments.push('container')
			if (this.minidrafter) instruments.push('minidrafter')
			if (this.frenchCurve) instruments.push('frenchCurve')
			if (this.scales) instruments.push('scales')
			const data = {
				imageUrl: this.imageUrl,
				contact: this.contact,
				instruments
			}
			const res = await axios.put(`api/instrument/${this.id}`, data)
			this.toggleModal()
			alert(res.data.message)
		},
		async handleDelete() {
			await axios.put(`api/instrument/${this.id}`, { sold: this.available ? false : true })
			this.$router.go()
		}
	},
	components: {
		Check,
		Uncheck
	},
	props: {
		date: String,
		available: Boolean,
		imageUrl: String,
		material: {
			type: Object,
			default: () => {}
		},
		contact: String,
		id: String
	}
}
</script>